import { render, staticRenderFns } from "./TheMainSideNav.vue?vue&type=template&id=3fbedc6c&scoped=true&"
import script from "./TheMainSideNav.vue?vue&type=script&lang=js&"
export * from "./TheMainSideNav.vue?vue&type=script&lang=js&"
import style0 from "./TheMainSideNav.vue?vue&type=style&index=0&id=3fbedc6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbedc6c",
  null
  
)

export default component.exports